export enum applicationSettingEnum {
  trainingProviderEventSearchFuture = "trainingProviderEventSearchFuture",
};
